import { useMemo } from "react";
import { buildFacilityDetailsViewModel } from "../utils/facilityDetails.utils";
import { useFacilitySourceTypeOptions } from "./useFacilitySourceTypeOptions";

export const useFacilityDetailsViewModel = (facilityData: any, countries: any[] | undefined) => {
  const { energyOptions, heatOptions, waterOptions, refrigerantOptions, isOptionsLoading } =
    useFacilitySourceTypeOptions();

  const viewModel = useMemo(
    () =>
      buildFacilityDetailsViewModel({
        facility: facilityData,
        countries,
        energyTypes: energyOptions,
        heatTypes: heatOptions,
        waterTypes: waterOptions,
        refrigerantTypes: refrigerantOptions
      }),
    [facilityData, countries, energyOptions, heatOptions, waterOptions, refrigerantOptions]
  );

  return { viewModel, isOptionsLoading };
};
